function shouldShowReport(flowType) {
  switch (flowType) {
    case "no-feedback":
      return false;
    default:
      return true;
  }
}

export { shouldShowReport };
//# sourceMappingURL=util.should-show-report.js.map
